import { pages } from "../content";
import { DocLink } from "./DocLink";
import type { SiteState } from "../app/site-state";
export function Sidebar(props: { site: SiteState }) {
  const site = props.site;
  const { menu } = site;
  const groups = [...new Set(pages.map((page) => page.group))];
  return (
    <aside id="sidebar" class={"sidebar " + (menu.value ? "is-open" : "")}>
      <div class="sidebar-scroll" data-zyra-scroll-prevent>
        <div class="sidebar-title">
          <span class="tiny-grid">▦</span> DOCUMENTATION
        </div>
        <nav aria-label="Documentation">
          {groups.map((group) => (
            <div class="nav-group">
              <h2>{group}</h2>
              {pages
                .filter((page) => page.group === group)
                .map((page) => (
                  <DocLink site={site} page={page} class="nav-link">
                    <span>{page.title}</span>
                    {!page.slug ? <span class="nav-dot" /> : null}
                  </DocLink>
                ))}
            </div>
          ))}
        </nav>
        <div class="sidebar-bottom">
          <span class="status-dot" />
          <span>
            Independent by design.<small>Reactive. Local. In motion.</small>
          </span>
          <span>↗</span>
        </div>
      </div>
    </aside>
  );
}
